import {useState, useRef, useEffect} from "preact/hooks"
import jwtDecode from "jwt-decode"

import {useInterval, useJitsi} from "../utils/hooks"
import {get, post, put} from "../utils/http"
import {getJaaSToken} from "./utils"
import * as styles from "./styles"
import { ModalWrapper, Modal } from "src/utils/fw"
import {Row, Column} from "./layout"

const Others = ({participants, tableName}) => {
	const [othersCard, setOthersCard] = useState(false)
	const close = e => {
		e.stopPropagation()
		setOthersCard(false)
	}

	return <div
		className="participant others"
		onclick={(e) => {
			e.stopPropagation()
			setOthersCard(true)
		}}
	>
		<span className="others_text" >and {participants.length - 7}<br />others</span>
		{othersCard
			? <Modal dismiss={close}>
					<ModalWrapper><OthersCard participants={participants} tableName={tableName} dismiss={close}/></ModalWrapper>
				</Modal>
			: null}
	</div>
}

const OthersCard = ({participants, dismiss, tableName}) => {
	return <Column
		styleOverride={{...styles.fcenter, padding: "5px", margin: "5px", width: "400px"}}
	>
		<h3 style={{padding: "5px", margin: "5px"}}>{tableName}</h3>
		<Row styleOverride={{flexWrap: "wrap"}}>	
			{participants.map(({name}, i) =>
				<p key={i} className="otherscard_name" style={{margin: "5px", padding: "5px"}}>{name}</p>,
			)}
		</Row>
		<button className="otherscard_close" style={{
			background: "none",
			border: "2px solid white",
			borderRadius: "6px",
			padding: "5px", margin: "5px",
		}} onclick={dismiss}>Close</button>
	</Column>
}

const InfoCard = ({participant, hide}) => <div
	style={{
		...styles.fcenter,
		...styles.fullscreen,
		...styles.whitewash
	}}
>
	<div
		style={{
			...styles.fr,
			...styles.fcenter,
			...styles.rounded,
			...styles.bg(styles.colors.agm21Color),
			...styles.pad("2vw"),
			...styles.rel
		}}
	>
		<p
			style={{
				...styles.abs,
				right: "5px",
				top: 0
			}}
			onclick={hide}
		>X</p>
		{participant.headshot && <img src={participant.headshot} style={{height: "18vw"}} />}
		<div style={{...styles.fc, ...styles.fcenter, alignItems: "stretch", marginLeft: "2vw"}}>
			<p>Company: {participant.company}</p>
			<p>Name: {participant.name}</p>
			<button style={{backgroundColor: "#ffffff", color: "#1994AC", border: 0, borderRadius: "0.5vw"}} onclick={() => window.openDM(participant.userRegID)}>Message me</button>
		</div>
	</div>
</div>

const Participant = participant => {
	const [isActive, setIsActive] = useState(false)
	const show = event => {
		event.stopPropagation()
		setIsActive(!isActive)
	}

	const hide = event => {
		event.stopPropagation()
		setIsActive(false)
	}

	return <div className={`participant participant${participant.id + 1}`} onclick={show}>
		{isActive ? <InfoCard participant={participant} hide={hide}/> : null}
		{participant.headshot ? <img style={{maxHeight: "100%", maxWidth: "100%"}} src={participant.headshot} title="click me for participant info" /> : participant.initials}
	</div>
}

const Table = ({id, participants = [], joinCall, seatsPerTable}) => {
	const overflowed = participants.length >= seatsPerTable
	return <div id={`table${id + 1}`} style={{cursor: "pointer"}} class="hotspot" onclick={() => {
		console.log("test")
		joinCall(id)
	}}>
		{participants
			.slice(0, overflowed ? seatsPerTable - 1 : seatsPerTable)
			.map(({id, ...rest}, i) => <Participant
				id={i}
				{...rest}
				userRegID={id}
			/>)
		}
		{overflowed ? <Others participants={participants} tableName={`Table ${id+1}`} /> : null}
	</div>
}

export const RoundTables = ({numTables = 3, seatsPerTable = 6, dataSource = "https://crs1.tkevents.io:3001"}) => {
	const [dataLayer] = window.dataLayer
	const {
		"First & Last Name": name,
		"Headshot": headshot,
		"Company": company,
		"Registrant ID": userRegID,
		"Event ID": eventID,
	} = dataLayer
	const email = dataLayer["Email Address"]
	const displayName = dataLayer["First & Last Name"]
	const avatarURL = dataLayer.Headshot
	const {current: jitsiWindowID} = useRef(Math.floor(Math.random() * 1e5))
	const [callNumber, setCallNumber] = useState(null)
	const [jwt, updatejwt] = useState("")
	useEffect(async () => {
		const interval = window.setInterval(
			async () => { updatejwt(await getJaaSToken()) },
			7200000,
		)

		updatejwt(await getJaaSToken())

		return () => window.clearInterval(interval)
	}, [])
	const options = {
		parentNode: document.getElementById(`${jitsiWindowID}`),
		roomName: callNumber === null ? null : `${jwtDecode(jwt).sub}/CCC Roundtable ${callNumber + 1}`,
		jwt,
	}
	const userInfo = {
		avatarURL,
		displayName,
		email,
	}
	useJitsi(options, "8x8.vc")

	const inCall = callNumber !== null
	const [tables, setTables] = useState(new Array(numTables).fill([]))

	const sendHeartbeat = async tableID => {
		const initials = name.split(" ").reduce((acc, val) => `${acc}${val[0]}`, "")

		try {
			const res = await put(
				`${dataSource}/rt/${userRegID}`,
				{company, eventID, headshot, initials, name, tableID},
			)

			if (res.status >= 300) {throw res}
		} catch (e) {
			if (e.status == 404) {
				await post(
					`${dataSource}/rt`,
					{company, eventID, headshot, id: userRegID, initials, name, tableID},
				)
			} else { throw e }
		}
	}

	useInterval(() => {
		if (inCall) { sendHeartbeat(callNumber) }
	}, 1000)

	useInterval(async () => {
		const newParticipants = await get(`${dataSource}/rt`, {maxAge: 3000})
		const newTables = (new Array(numTables).fill(null))
			.map(_ => [])
		newParticipants.sort((a, b) =>
			a.name > b.name ? 1 : -1,
		).forEach(({tableID, ...rest}) => {
			newTables[tableID].push(rest)
		})
		setTables(newTables)
	}, 1000)

	const joinCall = number => {
		setCallNumber(number)
		sendHeartbeat(number)
	}

	window.joincall = (arg) => {joinCall(arg)}

	return <>
		<div
			id={jitsiWindowID}
			style={{
				height: "calc(140.6% * 0.6666666)",
				left: "19%",
				position: "absolute",
				top: "0.8%",
				transform: "scale(0.75)",
				transformOrigin: "top left",
				width: "calc(123.6% * 0.6666666)",
			}}
		/>
		{Array(numTables)
			.fill([])
			.map((_, i) => <Table
				joinCall={joinCall}
				id={i}
				participants={tables[i]}
				seatsPerTable={seatsPerTable.length ? seatsPerTable[i] : seatsPerTable}
				onclick={console.log}
			/>)
		}
	</>
}
